import type { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'success' | 'danger' | 'warning';
  className?: string;
}

const variantClasses = {
  default: 'bg-accent-blue/10 text-accent-blue border-accent-blue/20',
  success: 'bg-accent-green/10 text-accent-green border-accent-green/20',
  danger: 'bg-accent-red/10 text-accent-red border-accent-red/20',
  warning: 'bg-accent-orange/10 text-accent-orange border-accent-orange/20',
};

export default function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-semibold rounded border ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
}
